// Mock data for Invoice Module - Ship Spare Logistics Application
// This file contains realistic mock data for demonstration purposes

export const mockSupplierInvoices = [
  {
    id: "SI-2026-0001",
    invoiceNumber: "INV-SUP-2026-0001",
    supplierName: "Global Freight Solutions Ltd",
    supplierId: 1,
    invoiceDate: new Date("2026-01-05"),
    dueDate: new Date("2026-02-04"),
    jobNumber: "VML-JOB-2026-0045",
    poNumber: "PO-2026-0123",
    status: "Pending Approval",
    totalAmount: 12500.00,
    paidAmount: 0,
    currency: "USD",
    paymentTerms: "Net 30 Days",
    taxAmount: 625.00,
    subtotal: 11875.00,
    invoiceType: "Freight Charges",
    description: "Sea freight charges for vessel MV OCEAN STAR",
    lineItems: [
      {
        id: 1,
        description: "Ocean Freight - Dubai to Rotterdam",
        quantity: 1,
        unitPrice: 8500.00,
        amount: 8500.00,
        taxRate: 5,
      },
      {
        id: 2,
        description: "THC Charges",
        quantity: 1,
        unitPrice: 1500.00,
        amount: 1500.00,
        taxRate: 5,
      },
      {
        id: 3,
        description: "Documentation Fees",
        quantity: 1,
        unitPrice: 750.00,
        amount: 750.00,
        taxRate: 5,
      },
      {
        id: 4,
        description: "Bill of Lading Charges",
        quantity: 3,
        unitPrice: 375.00,
        amount: 1125.00,
        taxRate: 5,
      },
    ],
    documents: [
      { id: 1, name: "Invoice.pdf", type: "Invoice" },
      { id: 2, name: "BL_Copy.pdf", type: "Bill of Lading" },
    ],
  },
  {
    id: "SI-2026-0002",
    invoiceNumber: "INV-SUP-2026-0002",
    supplierName: "Maritime Shipping Services",
    supplierId: 2,
    invoiceDate: new Date("2026-01-03"),
    dueDate: new Date("2026-01-18"),
    jobNumber: "VML-JOB-2026-0042",
    poNumber: "PO-2026-0118",
    status: "Approved",
    totalAmount: 8750.00,
    paidAmount: 0,
    currency: "EUR",
    paymentTerms: "Net 15 Days",
    taxAmount: 437.50,
    subtotal: 8312.50,
    invoiceType: "Customs Clearance",
    description: "Customs clearance and documentation",
    lineItems: [
      {
        id: 1,
        description: "Customs Clearance - Import",
        quantity: 1,
        unitPrice: 5000.00,
        amount: 5000.00,
        taxRate: 5,
      },
      {
        id: 2,
        description: "Duty Payment Processing",
        quantity: 1,
        unitPrice: 2500.00,
        amount: 2500.00,
        taxRate: 5,
      },
      {
        id: 3,
        description: "Certificate of Origin",
        quantity: 1,
        unitPrice: 812.50,
        amount: 812.50,
        taxRate: 5,
      },
    ],
    documents: [
      { id: 1, name: "Customs_Invoice.pdf", type: "Invoice" },
      { id: 2, name: "Clearance_Certificate.pdf", type: "Certificate" },
    ],
  },
  {
    id: "SI-2026-0003",
    invoiceNumber: "INV-SUP-2026-0003",
    supplierName: "Express Logistics Hub",
    supplierId: 3,
    invoiceDate: new Date("2025-12-28"),
    dueDate: new Date("2026-01-12"),
    jobNumber: "VML-JOB-2025-0312",
    poNumber: "PO-2025-0789",
    status: "Overdue",
    totalAmount: 4250.00,
    paidAmount: 0,
    currency: "USD",
    paymentTerms: "Net 15 Days",
    taxAmount: 212.50,
    subtotal: 4037.50,
    invoiceType: "Warehousing",
    description: "Warehouse storage and handling charges",
    lineItems: [
      {
        id: 1,
        description: "Warehouse Storage - December",
        quantity: 31,
        unitPrice: 100.00,
        amount: 3100.00,
        taxRate: 5,
      },
      {
        id: 2,
        description: "Handling Charges",
        quantity: 1,
        unitPrice: 937.50,
        amount: 937.50,
        taxRate: 5,
      },
    ],
    documents: [
      { id: 1, name: "Warehouse_Invoice.pdf", type: "Invoice" },
    ],
  },
  {
    id: "SI-2026-0004",
    invoiceNumber: "INV-SUP-2026-0004",
    supplierName: "AirCargo International",
    supplierId: 4,
    invoiceDate: new Date("2026-01-07"),
    dueDate: new Date("2026-02-06"),
    jobNumber: "VML-JOB-2026-0051",
    poNumber: "PO-2026-0134",
    status: "Draft",
    totalAmount: 18900.00,
    paidAmount: 0,
    currency: "USD",
    paymentTerms: "Net 30 Days",
    taxAmount: 945.00,
    subtotal: 17955.00,
    invoiceType: "Freight Charges",
    description: "Air freight shipment - urgent spare parts",
    lineItems: [
      {
        id: 1,
        description: "Air Freight - Singapore to Dubai",
        quantity: 1,
        unitPrice: 15000.00,
        amount: 15000.00,
        taxRate: 5,
      },
      {
        id: 2,
        description: "Fuel Surcharge",
        quantity: 1,
        unitPrice: 2250.00,
        amount: 2250.00,
        taxRate: 5,
      },
      {
        id: 3,
        description: "Security Charges",
        quantity: 1,
        unitPrice: 705.00,
        amount: 705.00,
        taxRate: 5,
      },
    ],
    documents: [
      { id: 1, name: "Draft_Invoice.pdf", type: "Invoice" },
    ],
  },
  {
    id: "SI-2025-0298",
    invoiceNumber: "INV-SUP-2025-0298",
    supplierName: "Port Services International",
    supplierId: 5,
    invoiceDate: new Date("2025-12-15"),
    dueDate: new Date("2026-01-14"),
    jobNumber: "VML-JOB-2025-0289",
    poNumber: "PO-2025-0723",
    status: "Paid",
    totalAmount: 6300.00,
    paidAmount: 6300.00,
    currency: "EUR",
    paymentTerms: "Net 30 Days",
    taxAmount: 315.00,
    subtotal: 5985.00,
    invoiceType: "Handling Charges",
    description: "Port handling and terminal charges",
    lineItems: [
      {
        id: 1,
        description: "Container Handling",
        quantity: 2,
        unitPrice: 2100.00,
        amount: 4200.00,
        taxRate: 5,
      },
      {
        id: 2,
        description: "Terminal Charges",
        quantity: 1,
        unitPrice: 1785.00,
        amount: 1785.00,
        taxRate: 5,
      },
    ],
    documents: [
      { id: 1, name: "Invoice.pdf", type: "Invoice" },
      { id: 2, name: "Payment_Receipt.pdf", type: "Receipt" },
    ],
  },
];

export const mockCustomerInvoices = [
  {
    id: "CI-2026-0001",
    invoiceNumber: "VML-INV-2026-0001",
    customerName: "Marine Engineering Solutions",
    customerId: 101,
    invoiceDate: new Date("2026-01-06"),
    dueDate: new Date("2026-02-05"),
    jobNumber: "VML-JOB-2026-0045",
    quotationNumber: "QT-2026-0023",
    status: "Approved",
    totalAmount: 15750.00,
    paidAmount: 0,
    currency: "USD",
    paymentTerms: "Net 30 Days",
    taxAmount: 787.50,
    subtotal: 14962.50,
    invoiceType: "Freight Charges",
    description: "Complete logistics service - spare parts delivery",
    lineItems: [
      {
        id: 1,
        description: "Sea Freight Charges",
        quantity: 1,
        unitPrice: 10000.00,
        amount: 10000.00,
        taxRate: 5,
      },
      {
        id: 2,
        description: "Customs Clearance",
        quantity: 1,
        unitPrice: 2500.00,
        amount: 2500.00,
        taxRate: 5,
      },
      {
        id: 3,
        description: "Documentation & Processing",
        quantity: 1,
        unitPrice: 1250.00,
        amount: 1250.00,
        taxRate: 5,
      },
      {
        id: 4,
        description: "Delivery to Vessel",
        quantity: 1,
        unitPrice: 1212.50,
        amount: 1212.50,
        taxRate: 5,
      },
    ],
    documents: [
      { id: 1, name: "Customer_Invoice.pdf", type: "Invoice" },
      { id: 2, name: "Delivery_Note.pdf", type: "Delivery Note" },
    ],
  },
  {
    id: "CI-2026-0002",
    invoiceNumber: "VML-INV-2026-0002",
    customerName: "Pacific Shipping Corporation",
    customerId: 102,
    invoiceDate: new Date("2026-01-04"),
    dueDate: new Date("2026-02-03"),
    jobNumber: "VML-JOB-2026-0042",
    quotationNumber: "QT-2026-0018",
    status: "Partially Paid",
    totalAmount: 22500.00,
    paidAmount: 10000.00,
    currency: "EUR",
    paymentTerms: "Net 30 Days",
    taxAmount: 1125.00,
    subtotal: 21375.00,
    invoiceType: "Freight Charges",
    description: "Air freight and express delivery services",
    lineItems: [
      {
        id: 1,
        description: "Air Freight - Urgent Delivery",
        quantity: 1,
        unitPrice: 18000.00,
        amount: 18000.00,
        taxRate: 5,
      },
      {
        id: 2,
        description: "Insurance Coverage",
        quantity: 1,
        unitPrice: 1875.00,
        amount: 1875.00,
        taxRate: 5,
      },
      {
        id: 3,
        description: "Express Clearance",
        quantity: 1,
        unitPrice: 1500.00,
        amount: 1500.00,
        taxRate: 5,
      },
    ],
    documents: [
      { id: 1, name: "Invoice.pdf", type: "Invoice" },
      { id: 2, name: "AWB.pdf", type: "Airway Bill" },
      { id: 3, name: "Partial_Payment_Receipt.pdf", type: "Receipt" },
    ],
  },
  {
    id: "CI-2026-0003",
    invoiceNumber: "VML-INV-2026-0003",
    customerName: "Global Vessel Supplies",
    customerId: 103,
    invoiceDate: new Date("2026-01-08"),
    dueDate: new Date("2026-01-23"),
    jobNumber: "VML-JOB-2026-0052",
    quotationNumber: "QT-2026-0029",
    status: "Pending Approval",
    totalAmount: 8925.00,
    paidAmount: 0,
    currency: "USD",
    paymentTerms: "Net 15 Days",
    taxAmount: 446.25,
    subtotal: 8478.75,
    invoiceType: "Warehousing",
    description: "Warehousing and distribution services",
    lineItems: [
      {
        id: 1,
        description: "Warehouse Storage - 15 Days",
        quantity: 15,
        unitPrice: 150.00,
        amount: 2250.00,
        taxRate: 5,
      },
      {
        id: 2,
        description: "Pick & Pack Services",
        quantity: 1,
        unitPrice: 3750.00,
        amount: 3750.00,
        taxRate: 5,
      },
      {
        id: 3,
        description: "Local Transportation",
        quantity: 1,
        unitPrice: 2478.75,
        amount: 2478.75,
        taxRate: 5,
      },
    ],
    documents: [
      { id: 1, name: "Invoice_Draft.pdf", type: "Invoice" },
    ],
  },
  {
    id: "CI-2025-0456",
    invoiceNumber: "VML-INV-2025-0456",
    customerName: "Nordic Maritime Services",
    customerId: 104,
    invoiceDate: new Date("2025-12-20"),
    dueDate: new Date("2025-12-27"),
    jobNumber: "VML-JOB-2025-0298",
    quotationNumber: "QT-2025-0187",
    status: "Overdue",
    totalAmount: 5250.00,
    paidAmount: 0,
    currency: "EUR",
    paymentTerms: "Due on Receipt",
    taxAmount: 262.50,
    subtotal: 4987.50,
    invoiceType: "Documentation Fees",
    description: "Documentation and certification services",
    lineItems: [
      {
        id: 1,
        description: "Certificate of Origin",
        quantity: 3,
        unitPrice: 500.00,
        amount: 1500.00,
        taxRate: 5,
      },
      {
        id: 2,
        description: "Customs Documentation",
        quantity: 1,
        unitPrice: 2250.00,
        amount: 2250.00,
        taxRate: 5,
      },
      {
        id: 3,
        description: "Bill of Lading Preparation",
        quantity: 1,
        unitPrice: 1237.50,
        amount: 1237.50,
        taxRate: 5,
      },
    ],
    documents: [
      { id: 1, name: "Invoice.pdf", type: "Invoice" },
      { id: 2, name: "Overdue_Notice.pdf", type: "Notice" },
    ],
  },
  {
    id: "CI-2025-0489",
    invoiceNumber: "VML-INV-2025-0489",
    customerName: "Atlantic Shipping Lines",
    customerId: 105,
    invoiceDate: new Date("2025-12-10"),
    dueDate: new Date("2026-01-09"),
    jobNumber: "VML-JOB-2025-0276",
    quotationNumber: "QT-2025-0165",
    status: "Paid",
    totalAmount: 31500.00,
    paidAmount: 31500.00,
    currency: "USD",
    paymentTerms: "Net 30 Days",
    taxAmount: 1575.00,
    subtotal: 29925.00,
    invoiceType: "Freight Charges",
    description: "Complete door-to-door logistics solution",
    lineItems: [
      {
        id: 1,
        description: "Ocean Freight",
        quantity: 1,
        unitPrice: 20000.00,
        amount: 20000.00,
        taxRate: 5,
      },
      {
        id: 2,
        description: "Inland Transportation",
        quantity: 1,
        unitPrice: 5000.00,
        amount: 5000.00,
        taxRate: 5,
      },
      {
        id: 3,
        description: "Customs & Clearance",
        quantity: 1,
        unitPrice: 3500.00,
        amount: 3500.00,
        taxRate: 5,
      },
      {
        id: 4,
        description: "Insurance",
        quantity: 1,
        unitPrice: 1425.00,
        amount: 1425.00,
        taxRate: 5,
      },
    ],
    documents: [
      { id: 1, name: "Final_Invoice.pdf", type: "Invoice" },
      { id: 2, name: "Payment_Confirmation.pdf", type: "Receipt" },
      { id: 3, name: "Delivery_POD.pdf", type: "POD" },
    ],
  },
];

// Helper function to get invoice by ID
export const getSupplierInvoiceById = (id) => {
  return mockSupplierInvoices.find(inv => inv.id === id);
};

export const getCustomerInvoiceById = (id) => {
  return mockCustomerInvoices.find(inv => inv.id === id);
};

// Helper function to filter invoices by status
export const filterInvoicesByStatus = (invoices, status) => {
  return invoices.filter(inv => inv.status === status);
};

// Helper function to calculate total outstanding
export const calculateOutstanding = (invoices) => {
  return invoices.reduce((total, inv) => {
    return total + (inv.totalAmount - inv.paidAmount);
  }, 0);
};
